import React from "react";

import CoverletterImage from "../CoverletterImage";
import { Container } from "@material-ui/core";
import Coverletter from "../Coverletter";
import Comparable from "../../Comparables/Comparable";
import TeamDetails from "../TeamDetails";
import NextSteps from "../NextSteps";
import MarketReport from "../MarketReport/index";
import Footer from "../Footer";

const AgentProfiling = () => (
  <>
    <CoverletterImage />
    <Container maxWidth="md" component="div" className="px-10" id="appraisal-details">
      <Coverletter />
      <TeamDetails awards difference profile community history/>
      <Comparable noPriceOpinion/>
      <MarketReport withoutSuburb/>
      <NextSteps salesProcess faq lookingFor preparingYourHome/>
    </Container>
    <Container maxWidth="md" component="div" className="px-10 pb-1">
      <Footer withoutTop/>
    </Container>
  </>
)

export default AgentProfiling;
